import { useState, useEffect } from 'react';

const ServicesPage = () => {
  const [activeCategory, setActiveCategory] = useState('residential');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = {
    residential: [
      {
        title: 'Panel Upgrades',
        description: 'Upgrade your electrical panel for improved safety and capacity',
        price: 'Starting at $1,200',
        image: 'https://public.readdy.ai/ai/img_res/bf64064e51b7d180aec36efe407798ed.jpg'
      },
      {
        title: 'EV Charger Installation',
        description: 'Professional electric vehicle charging station installation',
        price: 'Starting at $800',
        image: 'https://readdy.ai/api/search-image?query=Electric%20vehicle%20charger%20installation%20in%20residential%20garage%2C%20modern%20EV%20charging%20station%2C%20clean%20professional%20setup%2C%20bright%20lighting%2C%20high%20quality%20photography&width=400&height=300&seq=ev-charger&orientation=landscape'
      },
      {
        title: 'Potlight Installation',
        description: 'Modern LED potlight installation for enhanced lighting',
        price: 'Starting at $150 per light',
        image: 'https://readdy.ai/api/search-image?query=LED%20potlights%20installed%20in%20modern%20home%20ceiling%2C%20warm%20lighting%2C%20clean%20residential%20interior%2C%20professional%20installation%2C%20high%20quality%20photography&width=400&height=300&seq=potlights&orientation=landscape'
      },
      {
        title: 'Outlet Installation',
        description: 'New electrical outlet installation and GFCI upgrades',
        price: 'Starting at $120',
        image: 'https://readdy.ai/api/search-image?query=Electrical%20outlet%20installation%20in%20modern%20home%20wall%2C%20GFCI%20outlet%2C%20clean%20white%20background%2C%20professional%20electrical%20work%2C%20high%20quality%20photography&width=400&height=300&seq=outlet-install&orientation=landscape'
      },
      {
        title: 'Ceiling Fan Installation',
        description: 'Professional ceiling fan installation and wiring',
        price: 'Starting at $200',
        image: 'https://readdy.ai/api/search-image?query=Ceiling%20fan%20installation%20in%20modern%20home%2C%20professional%20electrician%20working%2C%20clean%20residential%20interior%2C%20proper%20wiring%2C%20high%20quality%20photography&width=400&height=300&seq=ceiling-fan&orientation=landscape'
      },
      {
        title: 'Home Rewiring',
        description: 'Complete home electrical rewiring for safety and efficiency',
        price: 'Contact for quote',
        image: 'https://readdy.ai/api/search-image?query=Home%20electrical%20rewiring%20project%2C%20professional%20electrician%20with%20copper%20wiring%2C%20modern%20electrical%20installation%2C%20clean%20background%2C%20high%20quality%20photography&width=400&height=300&seq=home-rewiring&orientation=landscape'
      }
    ],
    commercial: [
      {
        title: 'Office Electrical Setup',
        description: 'Complete electrical installation for office buildings',
        price: 'Contact for quote',
        image: 'https://readdy.ai/api/search-image?query=Commercial%20office%20electrical%20installation%2C%20modern%20office%20building%20interior%2C%20professional%20electrical%20panels%2C%20clean%20business%20environment%2C%20high%20quality%20photography&width=400&height=300&seq=office-electrical&orientation=landscape'
      },
      {
        title: 'Retail Store Lighting',
        description: 'Professional retail lighting design and installation',
        price: 'Starting at $500',
        image: 'https://readdy.ai/api/search-image?query=Retail%20store%20lighting%20installation%2C%20modern%20commercial%20LED%20lighting%2C%20professional%20retail%20environment%2C%20bright%20clean%20interior%2C%20high%20quality%20photography&width=400&height=300&seq=retail-lighting&orientation=landscape'
      },
      {
        title: 'Emergency Lighting',
        description: 'Emergency lighting systems for commercial buildings',
        price: 'Starting at $300',
        image: 'https://readdy.ai/api/search-image?query=Emergency%20lighting%20system%20in%20commercial%20building%2C%20exit%20signs%2C%20emergency%20lights%2C%20professional%20installation%2C%20clean%20modern%20interior%2C%20high%20quality%20photography&width=400&height=300&seq=emergency-lighting&orientation=landscape'
      },
      {
        title: 'Security System Wiring',
        description: 'Professional security system electrical installation',
        price: 'Contact for quote',
        image: 'https://readdy.ai/api/search-image?query=Security%20system%20wiring%20installation%20in%20commercial%20building%2C%20professional%20electrical%20work%2C%20security%20cameras%20and%20panels%2C%20clean%20modern%20setup%2C%20high%20quality%20photography&width=400&height=300&seq=security-wiring&orientation=landscape'
      },
      {
        title: 'Data Center Electrical',
        description: 'Specialized electrical work for data centers and server rooms',
        price: 'Contact for quote',
        image: 'https://readdy.ai/api/search-image?query=Data%20center%20electrical%20installation%2C%20server%20room%20electrical%20panels%2C%20professional%20cable%20management%2C%20modern%20technology%20environment%2C%20high%20quality%20photography&width=400&height=300&seq=data-center&orientation=landscape'
      },
      {
        title: 'Restaurant Kitchen Electrical',
        description: 'Commercial kitchen electrical installation and maintenance',
        price: 'Starting at $800',
        image: 'https://readdy.ai/api/search-image?query=Commercial%20restaurant%20kitchen%20electrical%20installation%2C%20professional%20kitchen%20equipment%20wiring%2C%20stainless%20steel%20environment%2C%20clean%20modern%20setup%2C%20high%20quality%20photography&width=400&height=300&seq=kitchen-electrical&orientation=landscape'
      }
    ],
    industrial: [
      {
        title: 'Motor Control Systems',
        description: 'Industrial motor control and automation systems',
        price: 'Contact for quote',
        image: 'https://readdy.ai/api/search-image?query=Industrial%20motor%20control%20system%20installation%2C%20electrical%20control%20panels%2C%20professional%20industrial%20environment%2C%20modern%20automation%20equipment%2C%20high%20quality%20photography&width=400&height=300&seq=motor-control&orientation=landscape'
      },
      {
        title: 'High Voltage Installation',
        description: 'High voltage electrical systems for industrial facilities',
        price: 'Contact for quote',
        image: 'https://readdy.ai/api/search-image?query=High%20voltage%20electrical%20installation%20in%20industrial%20facility%2C%20professional%20electrical%20equipment%2C%20safety%20gear%2C%20modern%20industrial%20environment%2C%20high%20quality%20photography&width=400&height=300&seq=high-voltage&orientation=landscape'
      },
      {
        title: 'Power Distribution',
        description: 'Industrial power distribution systems and panels',
        price: 'Contact for quote',
        image: 'https://readdy.ai/api/search-image?query=Industrial%20power%20distribution%20panel%20installation%2C%20electrical%20switchgear%2C%20professional%20industrial%20setting%2C%20modern%20electrical%20equipment%2C%20high%20quality%20photography&width=400&height=300&seq=power-distribution&orientation=landscape'
      },
      {
        title: 'Machinery Wiring',
        description: 'Electrical wiring for industrial machinery and equipment',
        price: 'Starting at $1,000',
        image: 'https://readdy.ai/api/search-image?query=Industrial%20machinery%20electrical%20wiring%2C%20professional%20electrician%20working%20on%20equipment%2C%20modern%20factory%20environment%2C%20electrical%20connections%2C%20high%20quality%20photography&width=400&height=300&seq=machinery-wiring&orientation=landscape'
      },
      {
        title: 'Facility Maintenance',
        description: 'Ongoing electrical maintenance for industrial facilities',
        price: 'Contact for quote',
        image: 'https://readdy.ai/api/search-image?query=Industrial%20facility%20electrical%20maintenance%2C%20professional%20electrician%20with%20testing%20equipment%2C%20modern%20industrial%20environment%2C%20electrical%20panels%2C%20high%20quality%20photography&width=400&height=300&seq=facility-maintenance&orientation=landscape'
      },
      {
        title: 'Emergency Power Systems',
        description: 'Backup power and emergency electrical systems',
        price: 'Contact for quote',
        image: 'https://readdy.ai/api/search-image?query=Emergency%20power%20system%20installation%20in%20industrial%20facility%2C%20backup%20generators%2C%20electrical%20transfer%20switches%2C%20professional%20setup%2C%20high%20quality%20photography&width=400&height=300&seq=emergency-power&orientation=landscape'
      }
    ]
  };

  const categories = [
    { id: 'residential', name: 'Residential', icon: 'ri-home-4-line' },
    { id: 'commercial', name: 'Commercial', icon: 'ri-building-line' },
    { id: 'industrial', name: 'Industrial', icon: 'ri-factory-line' }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-red-900 to-red-700 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Professional Electrical Services
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            Comprehensive electrical solutions for residential, commercial, and industrial needs in GTA
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/16472442797?text=Hi%20OhmEX%20Electric!%20I%20need%20electrical%20services."
              className="bg-yellow-500 hover:bg-yellow-600 text-black px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
            >
              Get Free Estimate
            </a>
            <a
              href="https://wa.me/16472442797?text=Hi%20OhmEX%20Electric!%20I%20would%20like%20to%20speak%20with%20you."
              className="bg-transparent border-2 border-white hover:bg-white hover:text-red-900 px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Now
            </a>
          </div>
        </div>
      </section>

      {/* Category Tabs */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 whitespace-nowrap ${
                  activeCategory === category.id
                    ? 'bg-red-900 text-white shadow-lg'
                    : 'bg-white text-red-900 hover:bg-red-50 border border-red-200'
                }`}
              >
                <i className={`${category.icon} mr-2`}></i>
                {category.name}
              </button>
            ))}
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services[activeCategory as keyof typeof services].map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top transition-transform duration-300 hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-lg font-semibold text-red-900">{service.price}</span>
                    <a
                      href={`https://wa.me/16472442797?text=Hi%20OhmEX%20Electric!%20I%20want%20to%20order%20${service.title}.`}
                      className="bg-yellow-500 hover:bg-yellow-600 text-black px-6 py-2 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
                    >
                      Order Now
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Our Services */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose OhmEx Electric Services?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Professional electrical services with guaranteed quality and 24/7 availability
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-shield-check-line',
                title: 'Licensed & Insured',
                description: 'Fully licensed electricians with comprehensive insurance coverage'
              },
              {
                icon: 'ri-time-line',
                title: '24/7 Emergency Service',
                description: 'Round-the-clock emergency electrical services when you need us most'
              },
              {
                icon: 'ri-award-line',
                title: 'Quality Guarantee',
                description: 'All work comes with our satisfaction guarantee and warranty'
              },
              {
                icon: 'ri-money-dollar-circle-line',
                title: 'Competitive Pricing',
                description: 'Fair, transparent pricing with free estimates for all projects'
              }
            ].map((feature, index) => (
              <div
                key={index}
                className="text-center p-6 rounded-xl bg-gray-50 hover:bg-red-50 transition-all duration-300"
              >
                <div className="w-16 h-16 bg-red-900 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-red-900 to-red-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Contact us today for a free estimate on any electrical service. Available 24/7 for emergencies.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/16472442797?text=Hi%20OhmEX%20Electric!%20I%20need%20a%20free%20estimate."
              className="bg-yellow-500 hover:bg-yellow-600 text-black px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Get Free Estimate
            </a>
            <a
              href="https://wa.me/16472442797?text=Hi%20OhmEX%20Electric!%20I%20would%20like%20to%20speak%20with%20you."
              className="bg-transparent border-2 border-white hover:bg-white hover:text-red-900 px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call (647) 244-2797
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
